import React from 'react'
import styles from './card.module.css'

export const CardTitle = ({ classes, children }) => {
  return <div className={`${classes ? classes : ''} ${styles.cardTitle} `}>{children}</div>
}
